module.exports = __webpack_public_path__ + "static/img/about-us-en.05678ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/syscom/about-us-en.png
// module id = 4J4j
// module chunks = 0